import client from './rest/AdminClient';
/**
 * Downloads CSV file containing unified view column configuration
 * @returns {Promise} Promise that resolves with the CSV data
 */
export function downloadUVColumnConfigurationCsv() {
    return client({
        method: 'GET',
        path: '/api/reporting/unifiedview/columns/configuration/csv',
    })
        .then((response) => {
        return response;
    })
        .catch((error) => {
        console.error('Error downloading column configuration:', error);
        throw error;
    });
}
